import * as React from "react";
import toast from "react-hot-toast";
export const setToast = (message, type, position, duration) => {
  toast((t) => <span dangerouslySetInnerHTML={{ __html: message }}></span>, {
    duration: duration || 2000,
    position: position || "top-center",
    type,
  });
};
